import { render } from "./password-reset-request.vue?vue&type=template&id=dd4c0220&ts=true"
import script from "./password-reset-request.vue?vue&type=script&lang=ts"
export * from "./password-reset-request.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__